<template>

  <el-dialog title="공지" 
    :visible.sync="value" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :show-close="false"
    @open="dialogOpen">
    <el-form :model="form" ref="form" :label-width="'120px'">
      <el-form-item 
        label="관리자 이름" 
        prop="creator"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-input v-model="form.creator" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item 
        label="공지일" 
        prop="notice_date"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-date-picker
          v-model="form.notice_date"
          type="date"
          placeholder="공지일">
        </el-date-picker>
      </el-form-item>
      <el-form-item 
        label="공지 제목" 
        prop="notice_title"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-input
          placeholder="제목를 입력해 주세요"
          v-model="form.notice_title">
        </el-input>
      </el-form-item>
      <el-form-item
        label="공지 내용"
        prop="notice_content"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-input
          type="textarea"
          class="html-editor"
          :autosize="{ minRows: 4, maxRows: 12}"
          v-model="form.notice_content">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">취소</el-button>
      <el-button type="primary" @click="submitForm">확인</el-button>
    </span>
  </el-dialog>

</template>

<script>
import _ from 'lodash'
export default {
  props: ['value', 'notice'],
  methods: {
    async dialogOpen () {
      if (this.notice) {
        this.form.creator = this.notice.creator
        this.form.notice_title = this.notice.notice_title
        this.form.notice_content = this.notice.notice_content
        this.form.notice_date = this.notice.notice_date
        this.form.pk = this.notice.pk
      }
      else {
        let adminName = await this.$service.localdb.getItem('admin_name')
        this.form.creator = adminName || 'Admin'
        // this.form.notice_title = ''
        // this.form.notice_content = ''
        this.form.notice_date = this.$service.moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.form.pk = null
      }
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = _.clone(this.form)
          if (typeof params.notice_date !== 'string') {
            params.notice_date = this.$service.moment(params.notice_date).format('YYYY-MM-DD HH:mm:ss')
          }
          this.$emit('close', params)

          this.form.creator = ''
          this.form.lang = 1
          this.form.notice_title = ''
          this.form.notice_content = ''
          this.form.notice_date = this.$service.moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
          this.form.pk = null
          this.$nextTick(() => this.$refs.form.clearValidate())
        }
      });
    },
    close () {
      this.$emit('close')
      this.form.creator = ''
      this.form.lang = 1
      this.form.notice_title = ''
      this.form.notice_content = ''
      this.form.notice_date = this.$service.moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.form.pk = null
      this.$nextTick(() => this.$refs.form.clearValidate())
    }
  },
  data () {
    return {
      form: {
        creator: '',
        lang: 1,
        notice_title: '',
        notice_content: '',
        notice_date: this.$service.moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        pk: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.html-editor {
  /deep/ textarea { font-family: 'Malgun Gothic', sans-serif; }
  // border: 1px solid #ebebeb;
  // max-height: 800px;
}
</style>

